import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

const Hero: React.FC = () => (
  <section className="hero" id="home">
    <div className="hero-bg-pattern" />
    <div className="hero-accent-bar" />
    <div className="container hero-content" style={{ width: '100%' }}>
      <div className="hero-badge">
        <span className="hero-badge-dot" />
        Engineering Excellence
      </div>
      <h1 className="hero-title">
        Building<span className="hero-title-accent"> Tomorrow's</span><br />Infrastructure<br />Today
      </h1>
      <p className="hero-title-sub">NIDAVE Industrial Ventures Limited</p>
      <p className="hero-desc">
        A reputable construction company committed to delivering durable, functional, and high-quality
        infrastructure solutions — roads, buildings, car parks, and civil works that stand the test of time.
      </p>
      <div className="hero-cta">
        <a href="#catalogue" className="btn-primary">View Our Projects <ArrowRight size={16} /></a>
        <a href="#about" className="btn-outline">Learn More</a>
      </div>
      <div className="hero-stats">
        {[['50+','Projects Completed'],['30+','Years Experience'],['100%','Client Satisfaction'],['5','Core Services']].map(([n,l]) => (
          <div key={l}><div className="hero-stat-num">{n}</div><div className="hero-stat-label">{l}</div></div>
        ))}
      </div>
    </div>
    <a href="#about" style={{ position:'absolute', bottom:'32px', left:'50%', transform:'translateX(-50%)', color:'var(--text-muted)', display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', textDecoration:'none', fontSize:'0.72rem', fontFamily:'var(--font-condensed)', letterSpacing:'0.12em', textTransform:'uppercase' }}>
      Scroll <ChevronDown size={18} />
    </a>
  </section>
);
export default Hero;
